var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { CommunicationService } from '../../../services/communication.service';
import { SCREEN_SIZE } from '../../../classes/enums';
import { HasSubscriptions } from '../../../components/has-subscriptions';
import { InternalLinksService } from '../../../services/internalLinks.service';
import { TranslateService } from '@ngx-translate/core';
var CmsLinksComponent = /** @class */ (function (_super) {
    __extends(CmsLinksComponent, _super);
    function CmsLinksComponent(communicationService, internalLinksService, translateService) {
        var _this = _super.call(this) || this;
        _this.communicationService = communicationService;
        _this.internalLinksService = internalLinksService;
        _this.translateService = translateService;
        _this.showNew = false;
        // Enums
        _this.SCREEN_SIZE = SCREEN_SIZE;
        _this.showMore = false;
        _this.addSub(_this.communicationService.screenSize.subscribe(function (s) { return _this.screenSize = s; }));
        _this.addSub(_this.communicationService.footerLinksChange.subscribe(function (place) { return _this.getFooterLinks(place, _this.communicationService.listings.currentShownListingType.value); }));
        return _this;
    }
    CmsLinksComponent.prototype.getFooterLinks = function (place, listingCategory) {
        var _this = this;
        this.addSub(this.internalLinksService.getLinks(place.province, place.city, listingCategory).subscribe(function (result) { _this.links = result; }));
        this.addSub(this.translateService.get('relevant-links.explore-links').subscribe(function (title) {
            _this.title = title;
        }));
    };
    return CmsLinksComponent;
}(HasSubscriptions));
export { CmsLinksComponent };
